import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from '@phosphor-icons/react';
import { useAuth } from '../../contexts/AuthContext';

export default function TermsUpdateModal() {
  const { acceptTermsUpdate, acceptedTermsVersion } = useAuth();
  const isFirstTime = !acceptedTermsVersion;
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    setLoading(true);
    try {
      await acceptTermsUpdate();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div
        className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center space-x-3">
            <ShieldCheck size={24} className="text-pink-500" weight="fill" />
            <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">
              {isFirstTime ? 'Terms of Service' : 'Updated Terms'}
            </h2>
          </div>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            {isFirstTime
              ? <>Please review and accept our <strong>Terms of Service</strong> and <strong>Privacy Policy</strong> to continue.</>
              : <>We've updated our <strong>Terms of Service</strong> and <strong>Privacy Policy</strong>. Please review the changes before continuing.</>
            }
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/terms"
              className="text-center px-4 py-2 text-sm font-medium text-pink-600 dark:text-pink-400 border border-pink-200 dark:border-pink-800 rounded-lg hover:bg-pink-50 dark:hover:bg-pink-900/20 transition-colors"
            >
              Read Terms of Service
            </Link>
            <Link
              to="/privacy"
              className="text-center px-4 py-2 text-sm font-medium text-pink-600 dark:text-pink-400 border border-pink-200 dark:border-pink-800 rounded-lg hover:bg-pink-50 dark:hover:bg-pink-900/20 transition-colors"
            >
              Read Privacy Policy
            </Link>
          </div>

          <button
            onClick={handleAccept}
            disabled={loading}
            className="w-full px-4 py-3 bg-gradient-to-r from-orange-500 to-pink-500 text-white font-semibold rounded-xl hover:from-orange-600 hover:to-pink-600 transition-all disabled:opacity-50"
          >
            {loading ? 'Saving...' : isFirstTime ? 'I accept' : 'I accept the updated terms'}
          </button>
        </div>
      </div>
    </div>
  );
}
